import React, { useContext } from 'react';
// Libraries
import { EditOutlined } from '@ant-design/icons';
import { Form, message } from 'antd';
// Contexts
import { SIGAMContext } from '~/contexts/SIGAMContext';
// Own Components
import EditForm from './components/EditForm';
// Components
import Drawer from '~/components/drawer';
import Button from '~/components/button';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';
import { CapitalizeString } from '~/utils/Transformations';

export default function Add({ setUpdatePending, record }) {
  const { activeInstitution } = useContext(SIGAMContext);
  const [form] = Form.useForm();

  const DrawerBody = () => {
    return <EditForm form={form} record={record} />;
  };

  const EditButtonFooter = ({ CloseDrawer }) => {
    async function onFinish(data) {
      if (data.status) {
        if (data.status === true) {
          data.status = 'ACTIVE';
        } else {
          data.status = 'INACTIVE';
        }
      }
      const params = {
        operation: ['SIGAM', 'OrganizationalUnits', 'Edit'],
        urlParams: {
          institutionId: activeInstitution.id,
          organizationUnitId: record.id,
        },
        data,
      };
      const response = await SocialMeAPI(params);
      if (response.success) {
        message.success('Unidade Organizacional atualizada com sucesso!');
        CloseDrawer();
        return setTimeout(function () {
          setUpdatePending(true);
        }, 300);
      }
      return message.error('Alguma coisa aconteceu...');
    }
    return (
      <Button
        type="primary"
        onClick={() => {
          form
            .validateFields()
            .then((values) => {
              //form.resetFields();
              onFinish(values);
            })
            .catch((info) => {
              // console.log('Validate Failed:', info);
            });
        }}
      >
        Atualizar
      </Button>
    );
  };

  return (
    <Drawer
      Trigger={
        <Button icon={<EditOutlined />} type="default">
          Editar
        </Button>
      }
      title={`Editando ${CapitalizeString(record.name)}`}
      DrawerContentComponent={DrawerBody}
      footer
      footerCancelButton
      FooterMainButton={EditButtonFooter}
    />
  );
}
